import { render, staticRenderFns } from "./CatalogCompared.vue?vue&type=template&id=2ecb304a&scoped=true&"
import script from "./CatalogCompared.vue?vue&type=script&lang=js&"
export * from "./CatalogCompared.vue?vue&type=script&lang=js&"
import style0 from "./CatalogCompared.vue?vue&type=style&index=0&id=2ecb304a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecb304a",
  null
  
)

export default component.exports